import { Box, Typography, getColor, Button, Icons } from "fds";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import utilsCommon from "../../shared/utils/common";
import { getUserInfoFromLocalStorage } from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";
import classNames from "classnames";

interface IProps {
  pageType:
    | "favorite"
    | "fav_meeting"
    | "search"
    | "search_meeting"
    | "trash"
    | "receivedFile"
    | "sendFile"
    | "workgroups"
    | "workgroupFile"
    | "log"
    | "client"
    | "clientReadRequest" //클라이언트 + 열람요청 활성화;
    | "manageStorage" // 저장 공간 사용 현황
    | "manageStorage_myBox" // 저장 공간 사용 현황 - My Box
    | "manageStorage_trash" // 저장 공간 사용 현황 - 휴지통
    | "home_log" // 홈의 압축 이력
    | "workgroup_home_log" // 워크그룹 홈의 압축 이력
    | "compressed_log" // 압축 이력
    | "myFile_log"; // 파일 사용 로그
  handleClickButton?: () => void;
}
/** 필터를 적용하지 않은 초기 화면인데, 검색결과가 없을때 나오는 화면 */
const EmptyInitFilterPage: React.FC<IProps> = ({
  pageType,
  handleClickButton,
}) => {
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const { t } = useTranslation();
  const renderImg = () => {
    switch (pageType) {
      case "fav_meeting":
        return (
          <img
            src={require("../../shared/images/pages/Meeting/noMeeting.png")}
            style={{ marginTop: 160 }}
            alt="noFilter"
            width={200}
          />
        );
      case "search":
      case "search_meeting":
        return (
          <img
            src={require("../../shared/images/pages/File/emptySearch.png")}
            style={{
              marginTop: pageType && pageType?.includes("client") ? 0 : 160,
            }}
            alt="noFilter"
            width={200}
          />
        );
      case "trash":
        return (
          <img
            src={require("../../shared/images/pages/File/trash.png")}
            style={{ marginTop: 182 }}
            alt="noFilter"
            width={118}
          />
        );
      case "workgroups":
        return (
          <img
            src={require("../../shared/images/pages/Workgroup/ExistWorkgroup.png")}
            style={{ marginTop: 160 }}
            alt="noFilter"
            height={120}
            width={238}
          />
        );
      case "log":
        return (
          <img
            src={require("../../shared/images/pages/Meeting/noMeeting.png")}
            style={{ marginTop: 160 }}
            alt="noFilter"
            height={106}
            width={200}
          />
        );
      case "workgroup_home_log":
      case "home_log":
      case "compressed_log":
        return (
          <img
            src={require("../../shared/images/pages/Workgroup/noLog.png")}
            style={{ marginTop: pageType === "home_log" ? 95 : 145 }}
            alt="noFilter"
            height={211}
            width={228}
          />
        );
      default:
        return (
          <img
            src={require("../../shared/images/pages/File/emptyFilterDoc.png")}
            style={{ marginTop: pageType.includes("client") ? 0 : 160 }}
            alt="noFilter"
            width={200}
          />
        );
    }
  };
  const renderDescLetter = () => {
    switch (pageType) {
      case "fav_meeting":
      case "favorite":
        return t("bookmark.noFile");
      case "search":
        return t("search.noFile");
      case "trash":
        return t("trash.noFile");
      case "receivedFile":
        return t("sendingFile.noRecievedFile");
      case "sendFile":
        return t("sendingFile.noSendFile");
      case "workgroups":
        return utilsCommon.checkWorkgroupCreatePermission(loginDto)
          ? t("workgroup.noWorkgroupDesc")
          : t("workgroup.noWorkgroupNoPermDesc");
      case "workgroupFile":
        return utilsCommon.checkUploadFilePermission(loginDto)
          ? t("file.noFileList") + "\n" + t("file.dropHerePlz")
          : t("file.noFileList");
      case "clientReadRequest":
        return t("file.noReadRequestList");
      case "log":
        return t("log.noListLog");
      case "home_log":
        return t("log.noCompressLog");
      case "workgroup_home_log":
      case "compressed_log":
        return t("log.noSmallCompressLog");
      case "myFile_log":
        return t("log.noFileLog");
      default:
        return "";
    }
  };

  const renderTitleLetter = () => {
    switch (pageType) {
      case "search":
      case "search_meeting":
        return t("common.noFilterTitle");
      default:
        return t("common.noItemDisplay");
    }
  };
  return (
    <Box
      alignItems="center"
      direction="column"
      height={pageType.includes("client") ? 394 : undefined}
      justifyContent={pageType.includes("client") ? "center" : undefined}
    >
      {renderImg()}
      <Typography type="h3" classes="mg mt-20">
        {renderTitleLetter()}
      </Typography>
      <Typography
        type="body2_rg_long"
        classes={classNames("mg mt-8")}
        style={{ paddingBottom: pageType.includes("home_log") ? 68 : 0 }}
        whiteSpace="break-spaces"
        textAlign="center"
        exactColor={getColor("COLOR_TEXT_SECONDARY")}
      >
        {renderDescLetter()}
      </Typography>
      {pageType === "workgroups" &&
        utilsCommon.checkWorkgroupCreatePermission(loginDto) && (
          <Button
            label={t("workgroup.create")}
            btnStyle={"fill"}
            size={"lg"}
            classes="mg mt-20"
            leadingIcon={<Icons variant="line" label="plusCircle" />}
            onClick={handleClickButton}
          />
        )}
      {pageType === "workgroupFile" &&
        utilsCommon.checkUploadFilePermission(loginDto) && (
          <Button
            label={t("file.action.upload")}
            btnStyle={"fill"}
            size={"lg"}
            classes="mg mt-20"
            leadingIcon={<Icons variant="line" label="upload" />}
            onClick={handleClickButton}
          />
        )}
    </Box>
  );
};

export default EmptyInitFilterPage;
